import React from "react";
import styles from "./DomainStepper.module.scss";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import { Grid2 } from "@mui/material";

export function DomainStepper({ currentStep, ebsSite }) {
  const steps = [
    { number: 1, label: "Domain details" },
    { number: 2, label: "Point your domain" },
    { number: 3, label: "Add SSL Certificate" },
  ].filter((s) => !ebsSite || s.number !== 3);

  return (
    <Grid2 className={styles.stepper}>
      {steps.map((step, index) => {
        const isCompleted = step.number < currentStep;
        const isActive = step.number === currentStep;

        return (
          <Grid2
            key={step.number}
            className={`${styles.step} ${isCompleted ? styles.completed : ""} ${
              isActive ? styles.active : ""
            }`}
          >
            <Grid2 className={styles.flexbox}>
              <Grid2 className={styles.stepCircle}>
                {isCompleted ? (
                  <span className={styles.icon}>
                    <VerifiedOutlinedIcon />
                  </span>
                ) : (
                  <span className={styles.number}>{step.number}</span>
                )}
              </Grid2>
              {index < steps.length - 1 && (
                <Grid2 className={styles.stepLine}></Grid2>
              )}
            </Grid2>
            <Grid2 className={styles.stepLabel}>{step.label}</Grid2>
          </Grid2>
        );
      })}
    </Grid2>
  );
}
